import React from 'react';

import { Icon, SVG } from 'components/tokens/Icon';
import { IconType } from 'components/tokens/Icon/Icon';

import styles from './FlowHeading.module.scss';

interface FlowHeadingProps {
  title: string;
  icon?: SVG;
  iconType?: IconType;
  currentStep?: number;
  maxStep?: number;
}

export const FlowHeading: React.FC<FlowHeadingProps> = ({
  title,
  icon,
  iconType = IconType.Fill,
  currentStep,
  maxStep,
}) => (
  <div className={styles.wrapper}>
    {icon && (
      <span className={styles.icon}>
        <Icon size={48} icon={icon} type={iconType} />
      </span>
    )}
    {currentStep && maxStep && (
      <span className={styles.progress}>
        Steg {currentStep} av {maxStep}
      </span>
    )}
    <h1 className={styles.heading}>{title}</h1>
  </div>
);
